import React from "react";
import { Outlet } from "react-router";

function Insurance() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default Insurance;
